import { render, staticRenderFns } from "./elec-energy-basis-bar.vue?vue&type=template&id=04d566d0&scoped=true&"
import script from "./elec-energy-basis-bar.vue?vue&type=script&lang=js&"
export * from "./elec-energy-basis-bar.vue?vue&type=script&lang=js&"
import style0 from "./elec-energy-basis-bar.vue?vue&type=style&index=0&id=04d566d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d566d0",
  null
  
)

export default component.exports